import axios from "axios";
import React, { useEffect, useState } from "react";
import Menu from "../Navigations/MenuProComponent";
import LoadingComponent from "../Navigations/Loading";
import NavigationSimpleComponent from "../Navigations/NavigationSimpleComponent";
let timer: NodeJS.Timeout;

const BaseSimplePage = (props: any) => {
    const [redirect, setRedirect] = useState(false);
    const [usuario, setUsuario] = useState({ nome: '' });
    const [height, setHeight] = useState(0);
    const [toggleMenuCollapse, setToggleMenuCollapse] = useState(true);

    const [preferences, setPreferences] = useState<any | null>(() => {
        const storedPreferences = localStorage.getItem("preferences");
        return storedPreferences ? JSON.parse(storedPreferences) : [];
    });

    useEffect(() => {
        document.body.style.backgroundImage = "";
        setHeight((window.innerHeight) - 60 );
        window.addEventListener('resize', () => setHeight((window.innerHeight) - 60 ));

        // (async () => {
        //     try {
        //         let response = await axios.get('usuario');
        //         setUsuario(response.data);
        //     } catch (error) {
        //         setRedirect(true);
        //     }

        //     localRecursiveEvent();
        // })();
    }, []);

    function localRecursiveEvent() {
        if (props.recursiveEvent == null)
        {
            return;
        }

        clearTimeout(timer);
        try {
            timer = setTimeout(() => { props.recursiveEvent(); localRecursiveEvent(); }, 30000);
        } catch (ex) {
            timer = setTimeout(() => { props.recursiveEvent(); localRecursiveEvent(); }, 10000);
        }
    }

    return (
        <>
            <LoadingComponent show={props.loading} />
            <NavigationSimpleComponent usuario={usuario} setToggleMenuCollapse={() => setToggleMenuCollapse(!toggleMenuCollapse)} />

            <div className={`central-page container-fluid${preferences.darkMode ? ' bg-black':''}`}>
                <div className="row">
                    
                    <main id="main-height" className={'body-center-page-simple '+(preferences.darkMode?" bg-black":"")} style={{width:'100%', height: height, overflowY: 'auto'}}>
                        {props.children}
                    </main>
                </div>
            </div>
        </>
    );
}

export default BaseSimplePage;